import React, { useEffect, useState } from "react";
import { fmtClock } from "../lobby/lobby";
import s from "./ranked.module.scss";

// The search, MS Battle's FindingEnemy (MatchFound.tsx) as is: a radar with a
// rotating sweep, two rings and a centre dot, the title with three blinking
// dots and a line under it, and the clock, all in the enemy's pink. When the
// match lands the text flips ("Target acquired!"), a target blips on the
// radar, the clock goes, the border goes full colour; at the hand-off the card
// slides out to the right as the banner arrives.

export function Radar({ size = 64, found = false }: { size?: number; found?: boolean }) {
  return (
    <span className={`${s.radar} ${found ? s.radarFound : ""}`} style={{ width: size, height: size }} aria-hidden="true">
      <i className={s.sweep} /><i className={s.ringA} /><i className={s.ringB} /><i className={s.rdot} /><i className={s.blip} />
    </span>
  );
}

export default function FindingCard({ since, found = false, leaving = false, onCancel, onPlayNow, inModal = false, className = "" }: {
  since: number;          // ms epoch the search started
  found?: boolean;
  leaving?: boolean;      // the hand-off: slides out to the right
  onCancel?: () => void;
  onPlayNow?: () => void; // play Play Now while the search runs
  inModal?: boolean;
  className?: string;
}) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (found) return;
    const h = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(h);
  }, [found]);
  const secs = Math.max(0, Math.floor((now - since) / 1000));
  return (
    <div className={`${s.fcard} ${inModal ? s.fcardInModal : ""} ${found ? s.fcardFound : ""} ${leaving ? s.fcardLeaving : ""} ${className}`} aria-live="polite">
      <Radar size={64} found={found} />
      <div className={s.fstack}>
        <div className={`${s.ftext} ${s.ftextFinding}`}>
          <div className={s.ftitle}>Finding enemy<span className={s.fdots}><i /><i /><i /></span></div>
          <div className={s.fsub}>Searching the ladder for a worthy opponent</div>
        </div>
        <div className={`${s.ftext} ${s.ftextFound}`} aria-hidden={!found}>
          <div className={s.ftitle}>Target acquired!</div>
          <div className={s.fsub}>Get ready</div>
        </div>
      </div>
      <div className={s.fclock}>{fmtClock(secs)}</div>
      {onPlayNow && <button type="button" className={`${s.fcancel} ${s.fplay}`} onClick={onPlayNow}>Play while you wait</button>}
      {onCancel && <button type="button" className={s.fcancel} onClick={onCancel}>Cancel</button>}
    </div>
  );
}
